import React, { useCallback } from 'react';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import { triggerErrors } from '../adapters/ruleAdapter';
import StepPanel from '../kit/StepPanel';
import { IWizardStepProps, newTrigger, WizardTrigger } from '../wizardModel';
import TriggerForm from './TriggerForm';

const TW = `${TOrbit}.wizard`;

const QUESTION: Record<WizardTrigger['kind'], string> = {
  transaction: `${TW}.trigger.transaction.question`,
  loyalty: `${TW}.trigger.loyalty.question`,
  milestone: `${TW}.trigger.milestone.question`,
  reward: `${TW}.trigger.reward.question`,
  others: `${TW}.trigger.others.question`
};

/** Step 3/5: the trigger being edited, a Quest task or a Progress rule (6778:18228, :21745, :23596). */
const TriggerStep: React.FC<IWizardStepProps> = ({ state, update, next, back }) => {
  const { t } = useMultiLanguageTranslation();
  const type = state.type ?? 'stamp';
  const trigger = state.triggers[state.editing] ?? newTrigger('transaction');
  const change = useCallback(
    (patch: Partial<WizardTrigger>) =>
      update(current => ({
        ...current,
        triggers: current.triggers.map((item, index) =>
          index === current.editing ? { ...item, ...patch } : item
        )
      })),
    [update]
  );
  const title =
    type === 'quest'
      ? t(`${TW}.trigger.questTask`, { n: state.editing + 1 })
      : type === 'progress'
      ? t(`${TW}.trigger.progressRule`, { n: state.editing + 1 })
      : t(`${TW}.setup.${type}`);

  return (
    <StepPanel
      step="trigger"
      // 6985:4991 redraws the Progress task form in the 950 panel.
      narrow={type === 'progress'}
      title={title}
      question={t(QUESTION[trigger.kind])}
      errors={triggerErrors(trigger, type, t)}
      onNext={next}
      onBack={back}
    >
      <TriggerForm type={type} trigger={trigger} onChange={change} />
    </StepPanel>
  );
};

export default TriggerStep;
